import axios from '../shared/axios';
import * as events from './events';

export function saveRequestForQuote(data) {
    //axios.post(`/api/RequestForQuote/SaveRequestForQuote`, data);
    return new Promise((resolve, reject) => {
        axios.post(`/api/RequestForQuote/SaveRequestForQuote`, data)
            .then(result => {
                switch (data.actioncode) {
                    case 'CREATE':
                        events.onNotification_CREATED();
                        break;
                    case 'SAVE_DRAFT':
                        events.onNotification_DRAFT_SAVED();
                        break;
                    case 'COMMUNICATE':
                        events.onNotification_COMMUNICATED();
                        break;
                    case 'REPLY_DRAFT':
                        events.onNotification_REPLY_DRAFT_SAVED();
                        break;
                    case 'REPLY_SEND':
                        events.onNotification_REPLY_SENT();
                        break;
                    default:
                        alert('Unknown action code!');
                        break;
                }
                resolve(result);
            })
            .catch(error => reject(error));
    });
}

export function getRequestForQuote(requestforquoteid) {
    return axios.get(`/api/RequestForQuote/GetRequestForQuote?requestforquoteid=${requestforquoteid}`);
}

export function getContractRequestForQuotes(companyid, projectid, contractid, accessibleWfIds) {
    return axios.post(`/api/RequestForQuote/RegisterList`, { accessibleWfIds }, { params: { companyid, projectid, contractid } });
}

export function deleteRequestForQuoteDraft(requestforquoteid) {
    return new Promise((resolve, reject) => {
        axios.post(`api/RequestForQuote/DeleteDraft?requestforquoteid=${requestforquoteid}`)
            .then(result => {
                events.onNotification_DELETED();
                resolve(result);
            })
            .catch(error => reject(error));
    })
}

export function importRFQs(data) {
    return new Promise(async (resolve, reject) => {
        try {
            const result = await axios.post(`/api/RequestForQuote/Import`, data);
            events.onNotification_CREATED();
            resolve(result);
        }
        catch (err) {
            reject(err)
        }
    });
}

export function deleteRFQDrafts(data) {
    return new Promise(async (resolve, reject) => {
        try {
            const result = await axios.delete(`/api/RequestForQuote/BulkDeleteDraft`, { data: data });
            events.onNotification_DELETED();
            resolve(result);
        }
        catch (err) {
            reject(err)
        }
    });
}

export function communicateRFQDrafts(data) {
    return new Promise(async (resolve, reject) => {
        try {
            const result = await axios.put(`/api/RequestForQuote/BulkCommunicate`, data);
            events.onNotification_COMMUNICATED();
            resolve(result);
        }
        catch (err) {
            reject(err)
        }
    });
}